import React, { FunctionComponent, useState } from 'react';
import { Input, message, Space, Button } from 'antd';
import { Asset, SearchResult } from '@monorepo/types';
import { useStore } from '../../../../../helpers/use-store';
import { LoadingState, useLoading } from '@monorepo/react-components';
import SelectableAssetList from '../../../../../components/selectable-asset/selectable-asset-list';
import { PartialAsset } from '../../../../../components/selectable-asset/selectable-asset';
import { useTranslation } from 'react-i18next';

interface Props {
  asset: Asset | PartialAsset | null;
  onSelect: (partialAsset: PartialAsset) => void;
}

const StockFootage: FunctionComponent<Props> = ({ asset, onSelect }) => {
  const { t } = useTranslation();
  const [results, setResults] = useState<SearchResult[]>([]);
  const [prompt, setPrompt] = useState(asset?.prompt || '');
  const { loadingState, updateLoadingState } = useLoading();
  const {
    dataStore: { assetStore },
  } = useStore();

  const handleSearch = async () => {
    if (!prompt.trim()) {
      message.warning(t('assetsModal.stockMedia.enterSearchTerm'));
      return;
    }

    updateLoadingState(LoadingState.Loading);
    try {
      const searchResults = await assetStore.searchStockFootage(prompt);
      setResults(searchResults);
    } catch (error) {
      console.error('Error searching stock footage:', error);
      message.error(t('assetsModal.stockMedia.searchError'));
    } finally {
      updateLoadingState(LoadingState.Loaded);
    }
  };

  const isLoading = loadingState === LoadingState.Loading;

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Input.TextArea
        rows={4}
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder={t('assetsModal.stockMedia.placeholder')}
      />
      <Button
        type="primary"
        style={{ width: '100%' }}
        onClick={handleSearch}
        loading={isLoading}
      >
        {t('assetsModal.stockMedia.searchButton')}
      </Button>
      <SelectableAssetList
        currentAsset={asset}
        assets={results.map((result) => {
          return {
            ...result,
            prompt,
          };
        })}
        onSelect={onSelect}
      />
    </Space>
  );
};

export default StockFootage;
